<template>
	<div class="container">
		<b-container class="pb-5">
			<div class="bodyDestino">

				<md-table v-model="infoDestino" md-card md-fixed-header
					:class="{ 'balance-table': true, 'principal-table': true }" key="destino-table">

					<md-table-toolbar>
						<div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
							<div style="flex: 1; text-align: center;">
								<h1 class="md-title"><b><i>{{ f_titulo() }}</i></b></h1>
							</div>
						</div>
					</md-table-toolbar>

					<md-table-row slot="md-table-row" slot-scope="{ item }" :class="{ 'clickable-row': true }"
						@click="f_muestra(item)">
						<md-table-cell :md-label="labels.cuenta" class="text-center border"
							style="min-width: 100px; max-width: 120px;">
							{{ item.cuenta }}
						</md-table-cell>
						<md-table-cell :md-label="labels.descripcion" class="text-left border"
							style="min-width: 150px; max-width: 200px;">
							{{ item.descripcion }}
						</md-table-cell>
						<md-table-cell :md-label="labels.saldo_actual" class="text-right border"
							style="min-width: 110px; max-width: 130px;">
							{{ formato(item.saldo_actual) }}
						</md-table-cell>
						<md-table-cell :md-label="labels.funcional1" class="text-right border"
							style="min-width: 110px; max-width: 130px;">
							{{ formato(item.funcional1) }}
						</md-table-cell>
						<md-table-cell :md-label="labels.funcional2" class="text-right border"
							style="min-width: 110px; max-width: 130px;">
							{{ formato(item.funcional2) }}
						</md-table-cell>
						<md-table-cell :md-label="labels.ajuste_actual" class="text-right border"
							style="min-width: 110px; max-width: 130px;">
							{{ formato(item.ajuste_actual) }}
						</md-table-cell>
						<md-table-cell :md-label="labels.ajuste_funcional1" class="text-right border"
							style="min-width: 110px; max-width: 130px;">
							{{ formato(item.ajuste_funcional1) }}
						</md-table-cell>
					</md-table-row>
				</md-table>
				<md-dialog-actions class="action-buttons-sobrios">
					<div class="button-group-sobrio">
						<md-button v-if="infoOpcion == 2" class="md-raised md-primary action-btn-sobrio"
							@click="f_ajustar_todo()">
							<md-icon>playlist_add_check</md-icon>
							Ajustar Todo
						</md-button>
					</div>
				</md-dialog-actions>
			</div>
			<md-dialog :md-active.sync="showDialogEdit">
				<md-dialog-title class="text-center">
					<h3><b><i>{{f_titulo()}}<br>{{labels.origen}}</i></b></h3>
				</md-dialog-title>
				<md-dialog-content>
					<b-form-group @submit.prevent="editaInfoBalance">
						<b-row>
							<h4><b-col cols="2"><b><i>{{labels.cuenta}}</i></b></b-col></h4>
							<b-col cols="2">
								<h4>{{formEdit.cuenta}}</h4>
							</b-col>
							<b-col cols="8">
								<h4>{{formEdit.descripcion}}</h4>
							</b-col>
						</b-row>
						<b-row><b-col cols="2">
								<h4><b><i>{{labels.saldo_actual}}</i></b></h4>
							</b-col>
							<b-col cols="2"></b-col>
							<b-col cols="8">
								<h4>{{formEdit.saldo_actual}}</h4>
							</b-col></b-row>

						<b-row><b-col cols="4">
								<h4><b><i>{{labels.funcional1}}</i></b></h4>
							</b-col>
							<b-col cols="4">
								<h4><b><i>{{labels.promedio1}}</i></b></h4>
							</b-col>
							<b-col cols="4">
								<h4><b><i>{{labels.interna1}}</i></b></h4>
							</b-col></b-row>
						<b-row><b-col cols="4" class="border">
								<h4>{{formEdit.funcional1}}</h4>
							</b-col>
							<b-col cols="4" class="border">
								<h4>{{formEdit.promedio1}}</h4>
							</b-col>
							<b-col cols="4" class="border">
								<h4>{{formEdit.interna1}}</h4>
							</b-col></b-row>

						<b-row><b-col cols="4">
								<h4><b><i>{{labels.funcional2}}</i></b></h4>
							</b-col>
							<b-col cols="4">
								<h4><b><i>{{labels.promedio2}}</i></b></h4>
							</b-col>
							<b-col cols="4">
								<h4><b><i>{{labels.interna2}}</i></b></h4>
							</b-col></b-row>
						<b-row><b-col cols="4" class="border">
								<h4>{{formEdit.funcional2}}</h4>
							</b-col>
							<b-col cols="4" class="border">
								<h4>{{formEdit.promedio2}}</h4>
							</b-col>
							<b-col cols="4" class="border">
								<h4>{{formEdit.interna2}}</h4>
							</b-col></b-row>


						<b-row><b-col cols="3">
								<h4><b><i>{{labels.ajuste_actual}}</i></b></h4>
							</b-col>
							<b-col cols="1"></b-col>
							<b-col v-if="!eliminar" cols="8" class="col-lg-3 border">
								<md-field> <md-input v-model="v_ajuste_actual" type="text"
										v-on:blur="f_ajuste_actual"></md-input> </md-field>
							</b-col>
							<b-col v-if="eliminar" cols="8" class="col-lg-3 border">
								<md-field> <md-input v-model="v_ajuste_actual" type="text" readonly></md-input>
								</md-field>
							</b-col>
						</b-row>

						<b-row><b-col cols="4">
								<h4><b><i>{{labels.ajuste_funcional1}}</i></b></h4>
							</b-col>
							<b-col cols="4">
								<h4><b><i>{{labels.ajuste_promedio1}}</i></b></h4>
							</b-col>
							<b-col cols="4">
								<h4><b><i>{{labels.ajuste_interna1}}</i></b></h4>
							</b-col></b-row>
						<b-row>
							<b-col v-if="!eliminar" cols="4" class="col-lg-3 border">
								<md-field> <md-input v-model="v_ajuste_funcional1" type="text"></md-input> </md-field>
							</b-col>
							<b-col v-if="eliminar" cols="4" class="border">
								<md-field> <md-input v-model="v_ajuste_funcional1" type="text" readonly></md-input>
								</md-field>
							</b-col>
							<b-col v-if="!eliminar" cols="4" class="border">
								<md-field> <md-input v-model="v_ajuste_promedio1" type="text"></md-input> </md-field>
							</b-col>
							<b-col v-if="eliminar" cols="4" class="border">
								<md-field> <md-input v-model="v_ajuste_promedio1" type="text" readonly></md-input>
								</md-field>
							</b-col>
							<b-col v-if="!eliminar" cols="4" class="border">
								<md-field> <md-input v-model="v_ajuste_interna1" type="text"></md-input> </md-field>
							</b-col>
							<b-col v-if="eliminar" cols="4" class="border">
								<md-field><md-input v-model="v_interna1" type="text" readonly></md-input> </md-field>
							</b-col>
						</b-row>
						<b-row><b-col cols="4">
								<h4><b><i>{{labels.ajuste_funcional2}}</i></b></h4>
							</b-col>
							<b-col cols="4">
								<h4><b><i>{{labels.ajuste_promedio2}}</i></b></h4>
							</b-col>
							<b-col cols="4">
								<h4><b><i>{{labels.ajuste_interna2}}</i></b></h4>
							</b-col></b-row>
						<b-row>
							<b-col v-if="!eliminar" cols="4" class="col-lg-3 border">
								<md-field> <md-input v-model="v_ajuste_funcional2" type="text"></md-input> </md-field>
							</b-col>
							<b-col v-if="eliminar" cols="4" class="border">
								<md-field> <md-input v-model="v_ajuste_funcional2" type="text" readonly></md-input>
								</md-field>
							</b-col>
							<b-col v-if="!eliminar" cols="4" class="border">
								<md-field> <md-input v-model="v_ajuste_promedio2" type="text"></md-input> </md-field>
							</b-col>
							<b-col v-if="eliminar" cols="4" class="border">
								<md-field> <md-input v-model="v_ajuste_promedio2" type="text" readonly></md-input>
								</md-field>
							</b-col>
							<b-col v-if="!eliminar" cols="4" class="border">
								<md-field> <md-input v-model="v_ajuste_interna2" type="text"></md-input> </md-field>
							</b-col>
							<b-col v-if="eliminar" cols="4" class="border">
								<md-field><md-input v-model="v_interna2" type="text" readonly></md-input> </md-field>
							</b-col>
						</b-row>

					</b-form-group>
					<md-dialog-actions>
						<md-button v-if="!eliminar" class="md-primary" @click="f_restaurar()">Restaurar</md-button>
						<md-button v-if="!eliminar" class="md-primary" @click="grabeAjuste()">Guardar</md-button>
						<md-button v-if="eliminar" class="md-primary" @click="elimineAjuste()">Eliminar</md-button>
						<md-button class="md-accent" @click="showDialogEdit = false">Cerrar</md-button>
					</md-dialog-actions>
				</md-dialog-content>
			</md-dialog>
			<md-dialog :md-active.sync="showContraAjuste">
				<md-dialog-title class="text-center">{{f_titulo()}}<br>{{labels.origen}}</md-dialog-title>
				<md-dialog-content>
					<b-form-group @submit.prevent="editaInfoBalance">
						<b-row><b-col>
								<h4>{{labels.cuenta}}</h4>
							</b-col>
							<b-col cols="8"><md-field><md-input v-model="formEdit.cuenta"
										type="text"></md-input></md-field></b-col></b-row>
						<b-row><b-col>
								<h4>{{labels.descripcion}}</h4>
							</b-col>
							<b-col cols="8"><md-field><md-input v-model="formEdit.descripcion" type="text"
										readonly></md-input> </md-field></b-col></b-row>
						<b-row><b-col>
								<h4>{{labels.ajuste_actual}}</h4>
							</b-col>
							<b-col cols="8"><md-field> <md-input v-model="valor_ajustar_actual" type="text"
										readonly></md-input></md-field></b-col></b-row>
						<b-row><b-col>
								<h4>{{labels.ajuste_funcional}}</h4>
							</b-col>
							<b-col cols="8"><md-field> <md-input v-model="valor_ajustar_funcional1" type="text"
										readonly></md-input></md-field></b-col></b-row>
					</b-form-group>
					<md-dialog-actions>
						<md-button class="md-primary" @click="grabeAjuste()">Guardar</md-button>
						<md-button class="md-accent" @click="showDialogEdit = false">Cerrar</md-button>
					</md-dialog-actions>
				</md-dialog-content>
			</md-dialog>
		</b-container>
	</div>
</template>
<script>
import Balance from "@/services/BalanceNiif"


export default {
name: "EliminaDestino",

data: () => ({
	optDestino: [],
	showDialogEdit : false,
	showContraAjuste : false,
	formEdit: { },
	v_ajuste_actual : '',
	v_ajuste_funcional1: '',
	v_ajuste_promedio1: '',
	v_ajuste_interna1: '',
	v_ajuste_funcional2: '',
	v_ajuste_promedio2: '',
	v_ajuste_interna2: '',
	porcentaje: 1,
	vc_cuenta: "99999999",
	vc_descripcion : "Cuenta controlante",
	vc_saldo_actual : 0,
	vc_funcional1 : 0,
	vc_ajuste_actual : 0,
	vc_ajuste_funcional1 : 0,
	valor_ajustar_actual: 0,
	valor_ajustar_funcional1: 0,
	eliminar: false,
}),
props:[	'infocodReporte',
	'infoDestino',
	'infoOpcion',
	'infoEmpresa',
	'infoTipo',
	'infoVigencia',
	'infoSecuencia',
	'infoValorAjustarActual',
	'infoValorAjustarFuncional1'],
computed:{
	labels() {
		if (this.$store.state._language == "es-ES") {
			return {
				destino : "Cuenta Controlada",
				cuenta : "Cuenta",
				descripcion : "Descripcion",
				saldo_actual: "Saldo",
				funcional1 : "Funcional",
				funcional2 : "Funcional2",
				promedio1 : "Promedio",
				promedio2 : "Promedio2",
				interna1 : "Interna",
				interna2 : "Interna2",
				ajuste_actual : "Ajuste Saldo",
				ajuste_funcional1 : "Ajuste Funcional",
				ajuste_promedio1 : "Ajuste Promedio",
				ajuste_interna1 : "Ajuste Interna",
				ajuste_funcional2 : "Ajuste Funcional2",
				ajuste_promedio2 : "Ajuste Promedio2",
				ajuste_interna2 : "Ajuste Interna2",
				opcion : "Modificar",
                                ajustar : "Ajustar",
			}
		} else {
			return {
				destino : "Controling Accounts",
				cuenta : "Account",
				descripcion : "Description",
				saldo_actual: "Saldo",
				funcional1 : "Funcional",
				funcional2 : "Funcional2",
				promedio1 : "Average",
				promedio2 : "Average2",
				interna1 : "Internal",
				interna2 : "Internal2",
				ajuste_actual : "Balance Adjustment",
				ajuste_funcional1 : "Funcional Adjustment",
				ajuste_promedio1 : "Average Adjustment",
				ajuste_interna1 : "Internal Adjustment",
				ajuste_funcional2 : "Funcional Adjustment2",
				ajuste_promedio2 : "Average Adjustment2",
				ajuste_interna2 : "Internal Adjustment2",
				opcion : "Modify",
				ajustar : "Adjust",
			}
		}
	}
},
methods: {
	f_titulo() {
		let titulo = this.infoEmpresa+" "+this.infoTipo
		return titulo
	},
	formato(numero) {
		return  new Intl.NumberFormat('en-US',{ maximumFractionDigits: 0}).format(numero)
	},
	async f_muestra(r_destino) {
		if (this.infoOpcion == 2) {
			this.porcentaje = 1;
			if (r_destino.saldo_actual != 0) {
				this.porcentaje = r_destino.funcional1 / r_destino.saldo_actual;
			} else {
				if (r_destino.ajuste_actual != 0)
					this.porcentaje = r_destino.ajuste_funcional1 / r_destino.ajuste_actual;
			}
			this.eliminar = false;
			if (r_destino.origen == "C") {
				this.eliminar = true;
			}

			// VERIFICAR Y ACTUALIZAR VALORES 0 A 1 ANTES DE ABRIR EL MODAL
			try {
				const respuesta = await Balance.verificarYActualizarValoresCero({
					vigencia: r_destino.vigencia,
					secuencia: r_destino.secuencia,
					id_compania: r_destino.id_compania,
					tipo_ajuste: r_destino.tipo_ajuste,
					cuenta: r_destino.cuenta,
					tabla: "D" // Para destino
				});

				if (respuesta.data && respuesta.data.item) {
					// Usar los datos actualizados del backend
					this.formEdit = { ...respuesta.data.item };
				} else {
					this.formEdit = { ...r_destino };
				}
			} catch (error) {
				console.error("Error al actualizar valores:", error);
				this.formEdit = { ...r_destino };
			}

			this.v_ajuste_actual = this.formEdit.ajuste_actual;
			this.v_ajuste_funcional1 = this.formEdit.ajuste_funcional1;
			this.v_ajuste_promedio1 = this.formEdit.ajuste_promedio1;
			this.v_ajuste_interna1 = this.formEdit.ajuste_interna1;
			this.v_ajuste_funcional2 = this.formEdit.ajuste_funcional2;
			this.v_ajuste_promedio2 = this.formEdit.ajuste_promedio2;
			this.v_ajuste_interna2 = this.formEdit.ajuste_interna2;
			this.showDialogEdit = true;
		}
	},

	async verificarYActualizarValoresCero(item, tipo) {
		const camposAverificar = [
			'saldo_actual', 'funcional1', 'funcional2',
			'promedio1', 'promedio2', 'interna1', 'interna2',
			'ajuste_actual', 'ajuste_funcional1', 'ajuste_funcional2',
			'ajuste_promedio1', 'ajuste_promedio2', 'ajuste_interna1', 'ajuste_interna2'
		];

		let hayCeros = false;
		for (const campo of camposAverificar) {
			if (item[campo] === 0 || item[campo] === "0") {
				hayCeros = true;
				break;
			}
		}

		if (!hayCeros) {
			return false;
		}

		const valoresActualizados = { ...item };
		for (const campo of camposAverificar) {
			if (valoresActualizados[campo] === 0 || valoresActualizados[campo] === "0") {
				valoresActualizados[campo] = 1;
			}
		}

		try {
			await Balance.actualizarValoresCero(tipo, valoresActualizados);
			this.$toast.info("Se han actualizado valores de 0 a 1 para evitar divisiones por cero");
			return true;
		} catch (error) {
			this.$toast.error("Error al actualizar valores");
			console.error("Error:", error);
			return false;
		}
	},

	// NUEVO MÉTODO: Obtener el item actualizado después de la modificación
	async obtenerItemActualizado(itemOriginal) {
		try {
			// Aquí deberías implementar una llamada al backend para obtener 
			// los datos actualizados del item
			const respuesta = await Balance.obtenerItemActualizado(
				this.infoVigencia,
				this.infoSecuencia,
				itemOriginal.cuenta,
				"D" // Destino
			);

			if (respuesta.data && respuesta.data.item) {
				return respuesta.data.item;
			}
			return null;
		} catch (error) {
			console.error("Error al obtener item actualizado:", error);
			return null;
		}
	},
	f_ajustar_todo() {
		if (!this.infoDestino || this.infoDestino.length === 0) {
			this.$toast.error("No hay registros para ajustar");
			return;
		}

		const confirmar = confirm(`¿Ajustar todos los registros?\nEsta acción aplicará el ajuste automático a ${this.infoDestino.length} registros`);

		if (confirmar) {
			this.ejecutarAjusteTotal();
		}
	},

	async ejecutarAjusteTotal() {
		let registrosAjustados = 0;
		let errores = 0;

		for (const item of this.infoDestino) {
			if (item.origen !== "C") { 
				try {
					const ajusteActual = -item.saldo_actual;
					const ajusteFuncional1 = -item.funcional1;
					const ajustePromedio1 = -item.promedio1;
					const ajusteInterna1 = -item.interna1;
					const ajusteFuncional2 = -item.funcional2;
					const ajustePromedio2 = -item.promedio2;
					const ajusteInterna2 = -item.interna2;

					const registroAjustado = {
						...item,
						ajuste_actual: ajusteActual,
						ajuste_funcional1: ajusteFuncional1,
						ajuste_promedio1: ajustePromedio1,
						ajuste_interna1: ajusteInterna1,
						ajuste_funcional2: ajusteFuncional2,
						ajuste_promedio2: ajustePromedio2,
						ajuste_interna2: ajusteInterna2
					};

					await Balance.grabeAjuste("D", registroAjustado);
					registrosAjustados++;

					Object.assign(item, registroAjustado);

				} catch (error) {
					errores++;
					console.error("Error ajustando registro:", error);
				}
			}
		}

		if (errores === 0) {
			this.$toast.success(`Se ajustaron ${registrosAjustados} registros correctamente`);
		} else {
			this.$toast.warning(`Se ajustaron ${registrosAjustados} registros, con ${errores} errores`);
		}

		this.$emit('ajusteGuardado');
	},
	f_ajuste_actual() {
		if (this.v_ajuste_actual === "" || this.v_ajuste_actual === "0" ||
			this.v_ajuste_actual === 0 || isNaN(parseFloat(this.v_ajuste_actual))) {

			this.v_ajuste_funcional1 = 0;
			this.v_ajuste_promedio1 = 0;
			this.v_ajuste_interna1 = 0;
			this.v_ajuste_funcional2 = 0;
			this.v_ajuste_promedio2 = 0;
			this.v_ajuste_interna2 = 0;
		} else {
			const ajusteActualNum = parseFloat(this.v_ajuste_actual);

			const porcentaje = this.formEdit.saldo_actual !== 0
				? ajusteActualNum / this.formEdit.saldo_actual
				: 0;

			this.v_ajuste_actual = Math.round(ajusteActualNum * 100) / 100;
			this.v_ajuste_funcional1 = Math.round(this.formEdit.funcional1 * porcentaje * 100) / 100;
			this.v_ajuste_promedio1 = Math.round(this.formEdit.promedio1 * porcentaje * 100) / 100;
			this.v_ajuste_interna1 = Math.round(this.formEdit.interna1 * porcentaje * 100) / 100;
			this.v_ajuste_funcional2 = Math.round(this.formEdit.funcional2 * porcentaje * 100) / 100;
			this.v_ajuste_promedio2 = Math.round(this.formEdit.promedio2 * porcentaje * 100) / 100;
			this.v_ajuste_interna2 = Math.round(this.formEdit.interna2 * porcentaje * 100) / 100;
		}
	},
	f_restaurar() {
		this.v_ajuste_actual=-this.formEdit.saldo_actual
		this.v_ajuste_funcional1=-this.formEdit.funcional1
		this.v_ajuste_promedio1=-this.formEdit.promedio1
		this.v_ajuste_interna1=-this.formEdit.interna1
		this.v_ajuste_funcional2=-this.formEdit.funcional2
		this.v_ajuste_promedio2=-this.formEdit.promedio2
		this.v_ajuste_interna2=-this.formEdit.interna2
		this.formEdit.ajuste_actual=this.v_ajuste_actual
		this.formEdit.ajuste_funcional1=this.v_ajuste_funcional1
		this.formEdit.ajuste_promedio1=this.v_ajuste_promedio1
		this.formEdit.ajuste_interna1=this.v_ajuste_interna1
		this.formEdit.ajuste_funcional2=this.v_ajuste_funcional2
		this.formEdit.ajuste_promedio2=this.v_ajuste_promedio2
		this.formEdit.ajuste_interna2=this.v_ajuste_interna2
	},
	grabeAjuste() {
		let v_mensaje=""
		let v_error = false

		if (this.v_ajuste_actual == "" || this.v_ajuste_actual === null || this.v_ajuste_actual === undefined) {
			this.$toast.error("Diligenciar el campo Ajuste Actual")
			v_error = true
			return
		}

		this.v_ajuste_actual = parseFloat(this.v_ajuste_actual) || 0;

		let v_valor = -this.formEdit.saldo_actual
		if (v_valor > 0) {
			if (this.v_ajuste_actual > v_valor) {
				v_mensaje = "Valor no debe ser mayor a " + this.formato(v_valor)
				v_error = true
			}
		} else {
			if (this.v_ajuste_actual < v_valor) {
				v_mensaje = "Valor Ajuste no debe ser menor a " + this.formato(v_valor)
				v_error = true
			}
		}
		if (v_error) {
			this.$toast.error(v_mensaje)
			v_error = false
		}

		if (!v_error) {
			this.showDialogEdit = false;
			this.formEdit.ajuste_actual = this.v_ajuste_actual;
			this.formEdit.ajuste_funcional1 = this.v_ajuste_funcional1;
			this.formEdit.ajuste_promedio1 = this.v_ajuste_promedio1;
			this.formEdit.ajuste_interna1 = this.v_ajuste_interna1;
			this.formEdit.ajuste_funcional2 = this.v_ajuste_funcional2;
			this.formEdit.ajuste_promedio2 = this.v_ajuste_promedio2;
			this.formEdit.ajuste_interna2 = this.v_ajuste_interna2;

			Balance.grabeAjuste("D", this.formEdit)
				.then(() => {
					this.$toast.success("Información Grabada");
					this.$emit('ajusteGuardado');
				})
				.catch(() => {
					this.$toast.error("Información no Grabada");
					this.error = true;
				});
		}
	},
	elimineAjuste() {
		this.showDialogEdit=false
		this.formEdit.ajuste_actual=this.v_ajuste_actual
		this.formEdit.ajuste_funcional1=this.v_ajuste_funcional1
		Balance.elimineAjuste("D", this.formEdit)
			.then(() => {
				this.$toast.success("Informacion Grabada");
				this.$emit('ajusteGuardado');
				this.$emit('cierraDetalle');
			})
			.catch(() => {
				this.$toast.error("Informacion no Grabada");
				this.error = true;
			});
	},
  },
 mounted() {

},
watch:{
        optDestino(Destino){
            // console.log(levelDos)
            this.$emit('envDestino',Destino)
        }
    }
};
</script>

<style scoped>
.balance-table {
    font-size: 13px; /* Reducir ligeramente el tamaño de fuente */
    width: 100% !important;
}

.principal-table>>>.md-table {
    width: 100% !important;
    table-layout: fixed !important;
}

.principal-table>>>.md-table-cell {
    padding: 4px 6px !important; /* Reducir padding */
    white-space: nowrap !important; /* Evitar wrap */
    overflow: hidden !important;
    text-overflow: ellipsis !important;
}

.balance-table>>>.md-table-head {
    padding: 4px 6px !important;
    font-size: 12px !important; /* Headers más pequeños */
}

.clickable-row {
    cursor: pointer;
    transition: background-color 0.2s;
}

.clickable-row:hover {
    background-color: #f5f5f5 !important;
}

.border {
    border: 1px solid #dee2e6 !important;
}

.bodyDestino {
    width: 100%;
    overflow-x: auto; /* Cambiar a auto en lugar de hidden */
}

/* Asegurar que la tabla ocupe el 100% del contenedor */
.principal-table {
    min-width: 100% !important;
}

/* Estilos para botones sobrios */
.button-group-sobrio {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    margin: 20px 0;
}

.action-btn-sobrio {
    min-width: 120px;
    border-radius: 6px;
    text-transform: none;
    font-weight: 500;
    transition: all 0.3s ease;
}

.action-btn-sobrio .md-icon {
    margin-right: 8px;
}

.action-btn-sobrio:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.action-buttons-sobrios {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px 0;
}

/* Responsive */
@media (max-width: 768px) {
    .button-group-sobrio {
        flex-direction: column;
        align-items: stretch;
    }
    
    .action-btn-sobrio {
        min-width: auto;
    }
}
</style>

<style src="../main.css"></style>
